module.exports = __webpack_public_path__ + "assets/img/root-50db3b132b9afcacdd635a17f64edc08.png";


//////////////////
// WEBPACK FOOTER
// ./theroot/root-100-2019/src/img/root.png
// module id = 214
// module chunks = 0